import { get, post } from "../services/HttpService";
import { axiosIns } from "../services";

export class SmartCollectTransaction {
    constructor(transactionObject = {}) {
        this.set(transactionObject);
    }

    static validations = {
        id: [],
        uuid: [],
        amount: [
            // { required: true, message: "Amount is required." },
            {
                pattern: "^(0*[1-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$",
                message: "Please enter a valid amount.",
            },
        ],
    };

    static list = (queryData = {}, config = {}) => {
        return get(
            `v1/insta-collect/internal/transactions/`,
            queryData,
            config
        ).catch((error) => ({
            success: false,
            data: (error.response && error.response.data) || {},
            status: (error.response && error.response.status) || 400,
        }));
    };

    static list_v2 = (queryData = {}, config = {}) => {
        return get(`v2/insta-collect/internal/transactions/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    retrieve = (queryData) => {
        return get(
            `v1/insta-collect/internal/transactions/${this.id}/`,
            queryData,
            {}
        ).catch((error) => ({
            success: false,
            data: (error.response && error.response.data) || {},
            status: (error.response && error.response.status) || 400,
        }));
    };

    static SearchTransaction = (queryData) =>{
        return post(
            `v1/insta-collect/internal/transactions/search/`, queryData, {}
        ).catch(error => ({ 
            success: false, 
            data: (error.response && error.response.data) || {}, 
            status: (error.response && error.response.status) || 400 
        }));
    };

    validate_refund = (queryData) => {
        return post(
            `v1/insta-collect/internal/transactions/${this.id}/validate_refund/`,
            queryData,
            {}
        ).catch((error) => ({
            success: false,
            data: (error.response && error.response.data) || {},
            status: (error.response && error.response.status) || 400,
        }));
    };

    initiate_refund = (queryData) => {
        return post(
            `v1/insta-collect/internal/transactions/${this.id}/initiate_refund/`,
            queryData,
            {}
        ).catch((error) => ({
            success: false,
            data: (error.response && error.response.data) || {},
            status: (error.response && error.response.status) || 400,
        }));
    };

    
    retrigger_webhook = (queryData) => {
        return get(
            `v1/insta-collect/internal/transactions/${this.id}/retrigger_webhook/`,
            queryData,
            {}
        ).catch((error) => ({
            success: false,
            data: (error.response && error.response.data) || {},
            status: (error.response && error.response.status) || 400,
        }));
    };

    update_status = (queryData) => {
        return post(
            `v1/insta-collect/internal/transactions/${queryData.id}/capture/`,
            queryData,
            {}
        ).catch((error) => ({
            success: false,
            data: (error.response && error.response.data) || {},
            status: (error.response && error.response.status) || 400,
        }));
    };

    
    static download_report = (queryData = {}, config = {}) => {
        return axiosIns.request({
            url: 'v1/insta-collect/internal/transactions/reports/',
            method: 'POST',
            responseType: 'blob',
            data: queryData,
            headers: config.headers
        }).catch(error => ({ success: false, data: "Something went wrong", status: 500 }))
    }

    static redirect_to_drs = (queryData={}) => {
        return post(
            `v1/insta-collect/internal/transactions/view_dispute/`,
            queryData,
            {}
        ).catch((error) => ({
            success: false,
            data: (error.response && error.response.data) || {},
            status: (error.response && error.response.status) || 400,
        }));
    };

    /**
     * @memberof VirtualAccount
     * @type Getter Method
     * @takes void
     * @returns VirtualAccount Params
     */
    get = () => {
        return {
            id: this.id,
        };
    };

    /**
     * @memberof VirtualAccount
     * @type Setter Method
     * @takes VirtualAccount Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach((x) => (this[x] = values[x]));
    };

    /**
     * @memberof VirtualAccount
     * @type Setter Method
     * @takes VirtualAccount Params
     * @returns void
     */
    reset = () => {
        this.id = undefined;
    };
}
